module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/hero-320-195031faf5a6c52308331afdf62b46fc.jpg";